import axios from "axios";

// URL da API por ambiente:
// - dev (npm start): .env.development -> http://localhost:5194/api
// - produção (npm run build): .env.production -> /api (mesmo domínio, atrás do IIS)
export const API_BASE_URL = process.env.REACT_APP_API_URL || "/api";
export const URL_BASE = process.env.REACT_APP_URL_BASE || "";

export const api = axios.create({
  baseURL: API_BASE_URL,
  headers: { "Content-Type": "application/json" },
});

// Injeta o JWT do localStorage em todas as requisições (mesmo padrão dos demais projetos).
api.interceptors.request.use((config) => {
  try {
    const token =
      typeof window !== "undefined" ? window.localStorage.getItem("token") : null;
    if (token) {
      config.headers = config.headers || {};
      if (!config.headers.Authorization) {
        config.headers.Authorization = `Bearer ${token}`;
      }
    }
  } catch (_) {
    // localStorage indisponível — segue sem token.
  }
  return config;
});

// 401 → token ausente/expirado: limpa sessão e volta ao login (exceto na própria tela de login).
api.interceptors.response.use(
  (res) => res,
  (err) => {
    const status = err?.response?.status;
    const naTelaLogin = window.location.pathname.startsWith("/login");
    // 401 = token ausente/expirado; 403 no app de staff = token sem perfil válido
    // (ex.: sessão antiga sem o claim de staff). Em ambos os casos, refaz o login.
    if ((status === 401 || status === 403) && !naTelaLogin) {
      localStorage.removeItem("token");
      localStorage.removeItem("usuario");
      window.location.href = "/login";
    }
    return Promise.reject(err);
  }
);
